import { ChangeDetectionStrategy, Component, ElementRef, inject, input, output } from '@angular/core';

import { ButtonModule, DictionaryItem, IconModule } from '@hglobal/common';

interface Category extends DictionaryItem {
  tooltip?: string;
}

@Component({
  selector: 'pp-categories',
  imports: [ButtonModule, IconModule],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesComponent {
  el = inject(ElementRef);
  readonly categories = input<Category[]>();
  readonly canRemove = input(true);
  readonly changeCategories = output<any[]>();
  readonly removedIndex = output<number>();

  get array(): Array<number> {
    const count = 18;

    return Array.from({ length: count });
  }

  remove(index: number) {
    if (!this.canRemove()) {
      return;
    }

    this.removedIndex.emit(index);
  }
}
